import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "@/lib/axios";
import { API_PORTAL_URL } from "@/lib/config";

export const getAllMenuSectors = createAsyncThunk(
  "/Sector/SectorShowOnMenu",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/Sector/SectorShowOnMenu`,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Sectors:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllTours = createAsyncThunk(
  "/Tour/TourList",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Tour/TourList`,
        formData,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Tours:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllRoomTypes = createAsyncThunk(
  "RoomType/FindAllRoomType",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/RoomType/FindAllRoomType`,
        { RoomType: "" },
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Room Types:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getTourDetails = createAsyncThunk(
  "Tour/TourDetails",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Tour/TourDetails`,
        formData,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Tour Details:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllSectorIncremental = createAsyncThunk(
  "/Sector/FindAllSectorIncrementalSearch",
  async (Name: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Sector/FindAllSectorIncrementalSearch`,
        { SectorName: Name },
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Sectors:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllHotelIncremental = createAsyncThunk(
  "/Hotels/HotelSearchForWebsite",
  async (Name: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Hotels/HotelSearchForWebsite`,
        { HotelName: Name },
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Hotels:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllToursWithSectors = createAsyncThunk(
  "/Tour/TourListWithSectorData",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Tour/TourListWithSectorData`,
        formData,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Tours:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllSectorBySectorType = createAsyncThunk(
  "/Sector/FindAllSectorTypeWiseSector",
  async (type: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Sector/FindAllSectorTypeWiseSector`,
        { SectorType: type },
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Sectors:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// ─── SERVER (native fetch — call ONLY from Server Components / page.tsx) ────

export async function fetchAllToursWithSectors(formData: any) {
  try {
    const res = await fetch(`${API_PORTAL_URL}/Tour/TourListWithSectorData`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...formData }),
      next: { revalidate: 300 },
    });
    const json = await res.json();
    return json.Data ?? null;
  } catch {
    return null;
  }
}

export async function fetchTourDetails(formData: any) {
  try {
    const res = await fetch(`${API_PORTAL_URL}/Tour/TourDetails`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...formData }),
      next: { revalidate: 300 },
    });
    const json = await res.json();
    return json.Data ?? null;
  } catch {
    return null;
  }
}

// ─── SERVER (native fetch — call ONLY from Server Components / page.tsx) ────

export async function fetchAllActiveTours() {
  try {
    const res = await fetch(`${API_PORTAL_URL}/Tour/FindAllActiveTour`, {
      next: { revalidate: 600 },
    });
    const json = await res.json();
    return json.Data || [];
  } catch {
    return [];
  }
}
